// extracted by mini-css-extract-plugin
export default {"wrapper":"UserName_wrapper__ezOsg","hint":"UserName_hint__N-r5b","name":"UserName_name__nclvs","nameLabel":"UserName_nameLabel__boRzR","nameInput":"UserName_nameInput__AacnI"};